import React from "react";
import Slider from "react-slick";
import H1 from "../../elements/titles/H1";
import Button from "../../elements/buttons/Button";
import image3 from "../../../medias/images/LD0004576455_2_0004577387-removebg-preview.png";
import image2 from "../../../medias/images/heroImgNti.png";
import image4 from "../../../medias/images/image-3712-600x600-removebg-preview.png";
import image from "../../../medias/images/materiels-informatique-pc-portable-lenovo-thinkbook-15-iil-20sm0076fr-infinytech-reunion-1-removebg-preview.png";
import ProgressiveImg from "../../elements/images/ProgressiveImg";

const HerotopCarousel = ({ classe }) => {
  //carousel settings
  const settings = {
    dots: true,
    infinite: true,
    fade: true,
    speed: 700,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="heroPresentation mt-6">
      <Slider {...settings}>
        <HeroCarouselItem
          imageDatas={{ img: image, tiny: image, alt: "text alternatif" }}
        >
          <H1 classe="text-center md:text-left">
            Ton ordinateur complet <br className="hidden xl:block" /> à un prix
            njoh!!!
          </H1>
          <Para color="light" classe="my-3 text-center md:text-left">
            Obtient ton ordinateur une bonne fois pour toutes !
          </Para>
          <Button classe="mt-6 md:mt-4 relative z-[50]" link="/produits">
            Voir les produits
          </Button>
        </HeroCarouselItem>

        <HeroCarouselItem
          imageDatas={{ img: image2, tiny: image2, alt: "text alternatif" }}
        >
          <H1 classe="text-center md:text-left">
            Des accessoires de bonnes qualités
          </H1>
          <Para color="light" classe="my-3 text-center md:text-left">
            Un bon pc encore plus équipe de ses accessoires pour une meilleure
            expérience.
          </Para>
          <Button classe="mt-6 md:mt-4 relative z-[50]" link="/produits">
            En savoir plus
          </Button>
        </HeroCarouselItem>

        <HeroCarouselItem
          imageDatas={{ img: image3, tiny: image3, alt: "text alternatif" }}
        >
          <H1 classe="text-center md:text-left">
            Des factures et une garantie raisonnable
          </H1>
          <Para color="light" classe="my-3 text-center md:text-left">
            Nous vous donnons la garantie d'utilisation de vos produits !
          </Para>
          <Button classe="mt-6 md:mt-4 relative z-[50]" link="/produits">
            Visiter maintenant
          </Button>
        </HeroCarouselItem>

        <HeroCarouselItem
          imageDatas={{ img: image4, tiny: image4, alt: "text alternatif" }}
        >
          <H1 classe="text-center md:text-left text-primary">
            Profiter de la promotion chez nti-technologie
          </H1>
          <Para color="light" classe="my-3 text-center md:text-left">
            Les prix de nos produits sont en réduction profitez-en !
          </Para>
          <Button classe="mt-6 md:mt-4 z-[50]" link="/produits">
            J'en profite !
          </Button>
        </HeroCarouselItem>
      </Slider>
    </div>
  );
};

function HeroCarouselItem({ children, imageDatas }) {
  const { img, tiny, alt, title, classeImg } = imageDatas;

  return (
    <article
      className="flex items-center justify-center py-5 md:justify-start md:space-x-10 lg:px-10"
      style={{ backgroudColor: "#000000" }}
    >
      <ProgressiveImg
        img={img}
        tiny={tiny}
        alt={alt}
        title={title && title}
        classe={`${classeImg} hidden lg:inline-block h-[17em] lg:h-[20em] object-contain`}
      />
      <div className="flex flex-col items-center md:block">{children}</div>
    </article>
  );
}

const Para = ({ children }) => {
  return (
    <p className="tex-base mt-5 text-center font-nunito text-lg font-medium leading-relaxed text-smoot md:mt-3  md:text-left">
      {children}
    </p>
  );
};

export default HerotopCarousel;
